import React from 'react'
import styles from './styles.css'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import {Form, Field} from 'simple-react-form'
import Toggle from 'orionsoft-parts/lib/components/fields/Toggle'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'

@withMutation(gql`
  mutation setDocumentAdvancedSettings(
    $documentId: ID
    $isPublic: Boolean
    $requireTwoFactor: Boolean
    $organizationId: ID
  ) {
    setDocumentVisibility(
      documentId: $documentId
      isPublic: $isPublic
      organizationId: $organizationId
    ) {
      _id
      isPublic
    }
    setDocumentSignerRequirements(
      documentId: $documentId
      requireTwoFactor: $requireTwoFactor
      organizationId: $organizationId
    ) {
      _id
      requireTwoFactor
    }
  }
`)
@withMessage
export default class OwnerView extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    setDocumentAdvancedSettings: PropTypes.func,
    document: PropTypes.object
  }
  state = {}

  @autobind
  async save({isPublic, requireTwoFactor}) {
    this.setState({loading: true})
    try {
      await this.props.setDocumentAdvancedSettings(
        {
          documentId: this.props.document._id,
          isPublic,
          requireTwoFactor,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['getDocument']
        }
      )
      this.props.showMessage('Documento actualizado')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  render() {
    return (
      <div className={styles.container}>
        <Form
          ref={form => {
            this.form = form
          }}
          state={this.props.document}
          onSubmit={this.save}
        >
          <div className="row">
            <div className="col-xs-3 col-sm-2">
              <Field fieldName="isPublic" type={Toggle} />
            </div>
            <div className="col-xs-9 col-sm-10" style={{marginTop: '10px'}}>
              <label>Documento público</label>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-3 col-sm-2">
              <Field fieldName="requireTwoFactor" type={Toggle} />
            </div>
            <div className="col-xs-9 col-sm-10">
              <div className={styles.option}>
                <label>Requerir autentificación de dos factores para firmar</label>
              </div>
            </div>
          </div>
          <br />
          <Button primary loading={this.state.loading} onClick={() => this.form.submit()}>
            Guardar
          </Button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/AdvancedSettings/Advance/OwnerView/index.js